import { createSlice } from "@reduxjs/toolkit";

import { getConfiguration } from "./thunks";
import type { ConfigurationWizardState } from "./types";

const initialState: ConfigurationWizardState = {
  data: {}
};

const configurationWizardSlice = createSlice({
  name: "configurationWizard",
  initialState,
  reducers: {
    updateLoadingMessage: (
      state,
      {
        payload
      }: {
        payload: {
          projectId: string;
          environmentId: string;
          message: string;
        };
      }
    ) => {
      const { projectId, environmentId, message } = payload;
      const entry = state.data[projectId]?.[environmentId];
      if (entry?.phase === "loading") {
        entry.loadingMessage = message;
      }
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getConfiguration.pending, (state, { meta }) => {
        const { projectId, environmentId } = meta.arg;
        state.data[projectId] ??= {};
        // Replacing the whole entry clears any prior config/error/message.
        state.data[projectId][environmentId] = { phase: "loading" };
      })
      .addCase(getConfiguration.fulfilled, (state, { payload, meta }) => {
        const { projectId, environmentId } = meta.arg;
        state.data[projectId] ??= {};
        state.data[projectId][environmentId] = {
          phase: "result",
          config: payload.config,
          generatedAt: payload.generatedAt
        };
      })
      .addCase(getConfiguration.rejected, (state, { payload, meta }) => {
        const { projectId, environmentId } = meta.arg;
        state.data[projectId] ??= {};
        state.data[projectId][environmentId] = {
          phase: "error",
          error: payload?.error ?? "Failed to generate configuration"
        };
      });
  }
});

export default configurationWizardSlice.reducer;

export const { updateLoadingMessage } = configurationWizardSlice.actions;
